import swal from 'sweetalert2'

function showSwalAlert(message, type = null, allowOutside = true, btnText = null, html = null, input = null, downloadswal=null) {
    if(downloadswal) {
        let timerInterval
        downloadswal.fire({
            title: 'Descargando Archivo!',
            allowOutsideClick: allowOutside,
            html: '<br>'+message,
            onBeforeOpen: () => {
                swal.showLoading()
            },
            onClose: () => {
                clearInterval(timerInterval)
            }
        })
        return
    }
    switch (type) {
        case 'success':
        case 'warning':
        case 'error':
            return swal({
                type: type,
                html: message,
                allowOutsideClick: allowOutside,
                confirmButtonClass: 'btn btn-'+( type == 'error' ? 'danger' : type )+' btn-fill',
                buttonsStyling: false
            })
        case 'input':
            return swal({
                title: message,
                html: html,
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: btnText,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                input: input.type,
                inputPlaceholder: input.placeholder,
                buttonsStyling: false,
                allowOutsideClick: allowOutside
            })
        case 'next':
            return swal({
                title: message,
                html: html,
                confirmButtonText: btnText,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false,
                allowOutsideClick: allowOutside
            })
        case 'delete':
            return swal({
                title: 'Eliminar '+message,
                text: '¿Esta seguro que desea eliminar este '+html+'?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, Eliminalo!',
                cancelButtonText: 'No, Detente',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false,
                allowOutsideClick: allowOutside
            })
        case 'temporary':
            return swal({
                title: 'Activar contraseña Temporal de '+message,
                text: '¿Esta seguro que desea activarle la contraseña temporal a este '+html+'?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Activar Contraseña',
                cancelButtonText: 'Cancelar',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false,
                allowOutsideClick: allowOutside
            })
        default:
            return swal({
                title: message,
                html: html,
                type: (type == 0) ? 'warning' : 'success',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: btnText,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false,
                allowOutsideClick: allowOutside
            })
    }
}

export default showSwalAlert
